import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandProvider } from "@/context/BrandContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import BrandDetail from "@/pages/BrandDetail";
import BrandCalendar from "@/pages/BrandCalendar";
import PostDetail from "@/pages/PostDetail";
import ClientPortal from "@/pages/ClientPortal";
import ClientPost from "@/pages/ClientPost";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-app flex items-center justify-center text-subtle">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function StudioRoutes() {
  return (
    <BrandProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Protected><Dashboard /></Protected>} />
        <Route path="/brand/:brandId" element={<Protected><BrandDetail /></Protected>} />
        <Route path="/brand/:brandId/calendar" element={<Protected><BrandCalendar /></Protected>} />
        <Route path="/brand/:brandId/post/:postId" element={<Protected><PostDetail /></Protected>} />
      </Routes>
    </BrandProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { borderRadius: "4px", border: "1px solid #D8D8D4", background: "#fff", color: "#16161A", boxShadow: "none" } }} />
      <Routes>
        <Route path="/c/:token" element={<ClientPortal />} />
        <Route path="/c/:token/post/:postId" element={<ClientPost />} />
        <Route path="/*" element={<AuthProvider><StudioRoutes /></AuthProvider>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
